export default __webpack_public_path__ + "static/media/Tim-How.e7176df9.png";